module.exports = __webpack_public_path__ + "static/media/i87a.267787bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i87a.svg
// module id = 407
// module chunks = 12